import React, { useRef } from 'react';

export const usePlaceholderItems = (count: number, Component: React.FC) => {
  const items = useRef([...Array(count).keys()].map((_, i) => i));
  return items.current.map(i => <Component key={i} />);
};
